import NavItem from 'components/UI/NavItem';
import React from 'react';
import { useTranslation } from 'react-i18next';
function FooterNavItem({ text, href, to, translate, onClick }) {
    const { t } = useTranslation();
    if (!href && !to)
        return null;
    return (React.createElement(NavItem, { scrollToTop: true, to: to, href: href, callback: onClick }, text ? text : t(translate)));
}
export default FooterNavItem;
